import { render } from "./Organizations.vue?vue&type=template&id=ffa4fd0c"
import script from "./Organizations.vue?vue&type=script&lang=js"
export * from "./Organizations.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__